import Axios from '../config/axios';

export function getVersion() {
    return Axios.get("/api/GetVersion").then(response => response.data);
}
